import { ComponentFactoryResolver, EventEmitter, Injectable, ViewContainerRef } from '@angular/core';
import { PuzzleHelpDialogInjectableInterface } from './puzzle-help-dialog-injectable.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { ButtonBarButton } from '../buttons/button-bar-button';

@Injectable({
  providedIn: 'root',
})
export class PuzzleHelpDialogService {
  private viewContainer: ViewContainerRef;
  private injectViewContainer: ViewContainerRef;

  private buttonBarButtons: BehaviorSubject<Array<ButtonBarButton>> = new BehaviorSubject<Array<ButtonBarButton>>([]);
  public readonly buttonBarButtons$: Observable<Array<ButtonBarButton>> = this.buttonBarButtons.asObservable();

  public helpDialogRegistered: EventEmitter<null> = new EventEmitter<null>();

  private sideNavButtons: BehaviorSubject<Array<ButtonBarButton>> = new BehaviorSubject<Array<ButtonBarButton>>([]);
  public readonly sideNavButtons$: Observable<Array<ButtonBarButton>> = this.sideNavButtons.asObservable();

  constructor(private factoryResolver: ComponentFactoryResolver) {}

  registerViewContainer(viewContainerRef: ViewContainerRef, injectViewContainer: ViewContainerRef) {
    this.viewContainer = viewContainerRef;
    this.injectViewContainer = injectViewContainer;
    this.helpDialogRegistered.emit(null);
  }

  injectHelpComponent(ComponentClass, data: any = {}) {
    const factory = this.factoryResolver.resolveComponentFactory(ComponentClass);
    const component = factory.create(this.viewContainer.injector);
    const instance = component.instance as PuzzleHelpDialogInjectableInterface;
    instance.setData(data);
    this.injectViewContainer.insert(component.hostView);
  }

  injectButtonBarButtons(buttons: Array<ButtonBarButton> = []) {
    this.buttonBarButtons.next(buttons.filter((button) => !button.custom));
  }

  injectSideNavButtons(buttons: Array<ButtonBarButton> = []) {
    this.sideNavButtons.next(buttons.filter((button) => !button.custom));
  }
}
